import httpManager from "@/app/shared/utils/httpManager";

/**
 * Request a whatsapp template to a channel_customer id
 *
 * @param {Object} params
 * @param {Number} params.channelCustomerId
 * @param {Object} params.body Body with the template options
 *
 */
export async function requestTemplate({ channelCustomerId, body } = {}) {
  await httpManager.post(
    `/channels/channel-customer/${channelCustomerId}/whatsapp-templates/`,
    body
  );
}
